import React from 'react';
import DiscogsFulfilmentsTable from './components/DiscogsFulfilmentsTable';

const DiscogsFulfilments = () => (
  <DiscogsFulfilmentsTable />
);

export default DiscogsFulfilments;
